<template>
  <div>
    <div class="container">
      <data-table :data-set="subscriptions" :page-length="50" :columns="[
            {name: 'Email', prop: 'email', type: 'text'},
            {name: 'MC_UNIQUE_ID', prop: 'mc_unique_id', type: 'text'},
            {name: 'Status', prop: 'subscribed', type: 'boolean'},
            {name: 'Unsub Reason', prop: 'unsubscribe_reason', type: 'text'},
            {name: 'Created', prop: 'created_at', type: 'date', filter: ['moment', ['from', 'now']]},
            {name: 'Updated', prop: 'updated_at', type: 'date', filter: ['moment', ['from', 'now']]},
        ]"></data-table>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  data() {
    return {}
  },
  computed: mapGetters(['subscriptions'])
};
</script>



// WEBPACK FOOTER //
// Subscriptions.vue?29373b49